module.exports = __webpack_public_path__ + "img/joy_01.244490b0.png";